module.exports = __webpack_public_path__ + "static/assets/4aaa9282ea3ada18174e2880e633b489.svg";